import { AppState } from '../state/App.state';
import * as Token from './../actions/authToken.actions';
import { AuthTokenModel } from '../models/authToken.model';


const initialState: AuthTokenModel = {
    authToken: ''
};

export function AuthTokenReducer(state: AuthTokenModel = initialState, action: Token.Actions): AuthTokenModel {

    switch (action.type) {
        case Token.Auth_Token:
            return {
                ...state,
                authToken: action.payload
            }
        default:
            return state;
    }
}

export const selectAuthToken = (state: AppState) => state?.bearerToken;
